import React from "react";
import { number, object } from "prop-types";

import WruAlsoRead from "../../molecules/wru-also-read";
import NewsLetter from "./news-letter";
import { Standard337x280Container } from "../../rows/ad-free";

import "./story-sidebar.m.css";

const StorySideBar = ({ index, story }) => {
  return (
    <div styleName="side-bar-wrapper">
      <div styleName="ad-wrapper">
        <Standard337x280Container id="storyPrem1" story={story} />
      </div>
      <NewsLetter />
      <WruAlsoRead index={index} story={story} />
      <div styleName="ad-wrapper">
        <Standard337x280Container id="storyATFMid" story={story} />
      </div>
    </div>
  );
};

StorySideBar.propTypes = {
  index: number,
  story: object,
};

export default StorySideBar;
